// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4decf1ceac0b57c8c91e","655":"354658ee5fdc1e5d5ff0"}[chunkId] + ".js";
};